export default __webpack_public_path__ + "static/media/pageLeftBottomPolygon.5017e6cc.svg";